import React, {Component} from 'react';
import {LineupPlayerFinalHead} from 'components/organisms/lineup/components/desktop/lineup-details/component/lineup-player-final-head';
import LineupInterface from 'interfaces/lineups-data-interfaces/lineup-interface';

interface Props {
    lineup: LineupInterface;
}

class LineupDetails extends Component<Props> {
    render() {
        const {lineup} = this.props;

        return (
            <ul className="data-list">
                <li>
                    <strong>Proj:</strong> {lineup.totalAdminPoints}
                </li>
                <li>
                    <strong>Salary:</strong> {lineup.totalSalary}
                </li>
                <li>
                    <strong>FPts:</strong> {lineup.totalLineupPoints}
                </li>
                <LineupPlayerFinalHead lineup={lineup} />
                <li>
                    <strong>Total pOwn:</strong> {lineup.totalProjOwn}%
                </li>
            </ul>
        );
    }
}

export {LineupDetails};
